import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { comparisonRows } from '../data/salesContent';
import { SectionShell } from './SectionShell';
function Mark({
  value
}: {
  value: boolean;
}) {
  return value ? <span className="mx-auto flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500/15 ring-1 ring-emerald-400/40" data-id="element-33" data-mp="39cwqe4z3cc96">
      <Check className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-34" data-mp="2zgl6otx68k4p" />
      <span className="sr-only" data-id="element-35" data-mp="2zegvrs0uukux">Sí</span>
    </span> : <span className="mx-auto flex h-7 w-7 items-center justify-center rounded-full bg-crimson-600/12 ring-1 ring-crimson-500/30" data-id="element-36" data-mp="2vdwzeqo3vl9u">
      <X className="h-4 w-4 text-crimson-500" aria-hidden="true" data-id="element-37" data-mp="2qg59g270u98a" />
      <span className="sr-only" data-id="element-38" data-mp="2lhtytp8wjup0">No</span>
    </span>;
}
export function ComparisonSection() {
  return <SectionShell eyebrow="Tabla comparativa" title="Compáralo con cualquier otra opción" className="border-y border-gold-500/10 bg-noir-900" data-id="element-39" data-mp="ongyt7s1sjih">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto max-w-4xl overflow-hidden rounded-2xl border border-gold-500/20 bg-noir-800/70" data-id="element-40" data-mp="3afcpy5ub8st5">
        <div className="overflow-x-auto" data-id="element-41" data-mp="35gt3837w7czq">
          <table className="w-full min-w-[620px] border-collapse text-left" data-id="element-42" data-mp="35hupz4y9tnxa">
            <caption className="sr-only" data-id="element-43" data-mp="3t6dynll8g2pw">
              Comparación entre cursos online, YouTube gratis y este bundle
            </caption>
            <thead data-id="element-44" data-mp="3jg2huygg9z1l">
              <tr className="border-b border-gold-500/15 bg-noir-700/60" data-id="element-45" data-mp="3jgknumswzrmp">
                <th scope="col" className="px-6 py-4 text-[11px] font-bold uppercase tracking-widest2 text-cream/45" data-id="element-46" data-mp="3oem655iinmx4">
                  &nbsp;
                </th>
                <th scope="col" className="px-4 py-4 text-center text-[11px] font-bold uppercase tracking-wider text-cream/55" data-id="element-47" data-mp="fxrekm765oyc">
                  Cursos online
                  <span className="mt-1 block font-sans text-[10px] font-medium normal-case tracking-normal text-cream/35" data-id="element-48" data-mp="um13y0csiww9">
                    $200+
                  </span>
                </th>
                <th scope="col" className="px-4 py-4 text-center text-[11px] font-bold uppercase tracking-wider text-cream/55" data-id="element-49" data-mp="kmtsxjtj3ecb">
                  YouTube
                  <span className="mt-1 block font-sans text-[10px] font-medium normal-case tracking-normal text-cream/35" data-id="element-50" data-mp="gocl0y2a9ztu">
                    gratis
                  </span>
                </th>
                <th scope="col" className="bg-crimson-600/12 px-4 py-4 text-center text-[11px] font-bold uppercase tracking-wider text-gold-400" data-id="element-51" data-mp="6u3xypw0uz32">
                  Este bundle
                  <span className="mt-1 block font-sans text-[10px] font-medium normal-case tracking-normal text-cream/50" data-id="element-52" data-mp="3t4zr0appgy5w">
                    $9.99
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-53" data-mp="3k52yfy073f5k">
              {comparisonRows.map(row => <tr key={row.feature} className="border-b border-cream/[0.07] transition-colors last:border-b-0 hover:bg-noir-700/35" data-id="element-54" data-mp="1zk647vslorgw">
                  <th scope="row" className="px-6 py-4 text-[15px] font-normal text-cream/78" data-id="element-55" data-mp="28mnt6hzn3y7l">
                    {row.feature}
                  </th>
                  <td className="px-4 py-4 text-center" data-id="element-56" data-mp="1gvrdl9m73fgm">
                    <Mark value={row.courses} data-id="element-57" data-mp="1kva1me9bc6no" />
                  </td>
                  <td className="px-4 py-4 text-center" data-id="element-58" data-mp="1ktfhv39s2kl6">
                    <Mark value={row.youtube} data-id="element-59" data-mp="1pu35rg2pmlb6" />
                  </td>
                  <td className="bg-crimson-600/[0.07] px-4 py-4 text-center" data-id="element-60" data-mp="1um4l5av6cs5f">
                    <Mark value={row.bundle} data-id="element-61" data-mp="x67dcnk6bfk7" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
      <p className="mt-4 text-center text-xs text-cream/35 sm:hidden" data-id="element-62" data-mp="1237h2rtjw685">
        ← Desliza para ver la tabla completa →
      </p>
    </SectionShell>;
}